import { Stack, Typography } from '@mui/material';

import { Section } from '../styled';

function Pinned() {
  return (
    <Section sx={{ borderBottom: 'none' }}>
      <Stack gap={1.5}>
        <Typography variant="h6" color="text.muted">
          Pinned
        </Typography>
      </Stack>
      <Stack alignItems="center" justifyContent="center" height={150}>
        <Typography color="text.muted" variant="body2">
          Nothing pinned yet
        </Typography>
      </Stack>
    </Section>
  );
}

export default Pinned;
